export default {
    api: 'https://lyra-ai-backend-mcjef.ondigitalocean.app',
    // api: 'http://localhost:5026',
}


// WEBPACK FOOTER //
// ./src/config/index.js